import { MAINTENANCE, SLUDGE_EMPTYING, SPANC } from '../utils/rikutec';

const locale = {
    app: {
        actions: {
            refresh: 'Actualiser',
            addItem: 'Créer',
            editItem: 'Modifier',
            deleteItem: 'Supprimer',
            title: 'Actions'
        },
        ancsV2: {
            actions: {
                history: 'Historique',
                forms: 'Formulaires',
            },
            subtabs: {
                install: 'Installation',
                installHint: 'Suivi, produit et typologie de sol',
                coord: 'Coordonnées',
                coordHint: 'Propriétaire, lieu, installateur et distributeur',
                recep: 'Réception des travaux',
                recepHint: 'Procès-verbal et état des réserves',
            },
            formsTitle: 'traçabilité',
            signatures: {
                owner: "Maître d'ouvrage",
                installer: "Maître d'oeuvre",
                ownerRole: 'propriétaire',
                installerRole: 'installateur',
                signed: 'Signée',
                pending: 'En attente',
                missing: 'Non signée',
                unavailable: 'Signature non disponible',
                others: 'Autres signatures',
            },
            files: {
                title: 'Fichiers',
                document: 'Document',
                step: 'Étape',
                date: 'Date',
                action: 'Action',
                empty: "Aucun fichier dans l'historique",
                error: "Impossible de charger les fichiers de l'historique",
                download: 'Télécharger',
            },
            personalData: 'Données perso.',
            process: {
                older: 'Ancien processus',
                current: 'Processus actuel',
                both: 'Ancien puis actuel',
                pose: "Pose par l'installateur",
                landOwner: 'Pose par le propriétaire du terrain',
                commissioning: 'Mise en service par le propriétaire',
                noForm: "Aucun formulaire dans l'historique",
            },
            checks: {
                waterRunoff: 'Implantation : eaux de ruissellement détournées',
                steepSlope: 'Implantation : forte pente maîtrisée',
                devicesInWater: "Implantation : pas plus de 1,10 m dans l'eau",
                evacuationAndVentilation: 'Implantation : évacuation et ventilations conformes',
                noLoadWithin3Meters: 'Implantation : pas de charge à moins de 3 m',
                rapidRecovery: 'Implantation : reprise rapide de la végétation',
                notInFloodProneArea: 'Implantation : hors zone inondable',
                waterDecanter: 'Décanteur en eau',
                basketInPlace: 'Panier en place dans la fosse septique',
                downstreamLiftingDevice: 'Relevage aval optionnel fonctionnel et sécurisé',
                biologicalWaterReactor: 'Réacteur biologique en eau, armoire raccordée',
                gravityFlow: "Écoulement gravitaire depuis l'alimentation",
                biologicalFilterVentilation: 'Ventilation du filtre biologique fonctionnelle',
                closedAndSecureBuffers: 'Tampons fermés et sécurisés',
                ownerInformed: 'Propriétaire informé du fonctionnement',
            },
            groups: {
                information: 'Informations',
                tracking: 'Suivi',
                product: 'Informations produit',
                client: 'Coordonnées du propriétaire',
                installation: "Lieu d'installation",
                installer: "Coordonnées de l'installateur",
                distributor: 'Coordonnées du distributeur',
                soil: 'Typologie de sol',
                reception: 'Procès-verbal de réception des travaux',
                reserves: 'État des réserves',
                signatures: 'Signatures',
                siteChecks: 'Contrôles de pose',
            },
            columns: {
                model: 'Modèle',
                lastMaintenance: 'Dernière maintenance',
                lastEmptying: 'Dernière vidange',
                processingCapacity: 'Capacité de traitement',
                clientFullName: 'Client',
                installerCompany: 'Installateur',
                installationCity: "Ville d'installation",
                readyToDeliverDate: 'Prête à livrer',
                poseDate: 'Date de pose',
                reserveLiftDate: 'Lever les réserves',
                hasOwnerSignature: "Signature maître d'ouvrage",
                hasInstallerSignature: "Signature maître d'oeuvre",
            },
            // Wording of the Rikutec process forms (coreapi, RikutecExtBundle CreateProcess* commands).
            forms: {
                loadError: 'Impossible de charger toutes les informations de cette installation',
                notAsked: 'Non demandé par ce processus',
                lastName: 'Nom',
                firstName: 'Prénom',
                company: 'Société',
                address: 'Adresse',
                postalCode: 'Code postal',
                city: 'Ville',
                country: 'Pays',
                email: 'Email',
                phone: 'Téléphone',
                invoiceDate: 'Date de pose ou de facture',
                serialNumber: 'Numéro de série du produit',
                nominalCapacity: 'Capacité nominale',
                totalUsefulVolume: 'Volume utile total',
                sludgeStorageVolume: 'Volume de stockage des boues',
                stableBedding: 'Sol perméable et stable : lit de pose',
                stableBackfilling: 'Sol perméable et stable : remblayage latéral',
                impermeableSlab: 'Sol imperméable : radier en béton ferraillé',
                impermeableBedding: 'Sol imperméable : lit de pose en béton maigre',
                impermeableBackfilling: 'Sol imperméable : remblayage latéral',
                unstableBedding: 'Sol instable : lit de pose en béton maigre',
                unstableBackfilling: 'Sol instable : remblayage latéral',
                quoteNumber: 'Devis n°',
                workInformation: 'Relatif aux travaux',
                withReserve: 'Réception avec réserve',
                conditionsReceived: "Conditions d'usage et d'entretien reçues",
                madeIn: 'Fait à',
                madeOn: 'Le',
                privacyAccepted: 'Politique de confidentialité acceptée',
                kindOfReserve: 'Nature des réserves',
                workToBePerformed: 'Travaux à exécuter',
                workPeriod: "Délai global d'exécution",
                answers: {
                    yes: 'Oui',
                    no: 'Non',
                },
                soilOptions: {
                    form8: 'Pose en sol perméable, stable et sans eau souterraine',
                    form9: "Pose en sol en terrain imperméable ou avec présence d'eau souterraine",
                    form10: 'Pose en sol instable ou peu perméable, sans eau souterraine',
                },
            },
            filters: {
                clientFullName: 'Client',
                installerCompany: 'Installateur',
                distributorCompany: 'Distributeur',
                installationCity: "Ville d'installation",
            },
        },
        ancs: {
            qrScan: {
                button: 'Scanner QR',
                clear: 'Afficher tout',
                title: 'Scanner le QR de la pièce',
                hint: 'Placez le QR dans le cadre',
                notFound: 'Aucune pièce trouvée pour ce QR',
                searchFailed: 'Échec de la recherche',
                cameraNotAvailable: 'Caméra non disponible ou déjà utilisée',
                permissionDenied: "Accès à la caméra refusé",
                noCamera: 'Aucune caméra accessible',
                selectCamera: 'Caméra',
                camera: 'Caméra',
            },

            departmentFilter: {
                label: 'Départements',
                all: 'tous',
                title: 'Cliquez sur les départements à afficher',
                selected: 'Sélectionnés',
                hint: 'Seules les ANC avec un code postal renseigné sont retrouvées.',
                clear: 'Tout effacer',
                cancel: 'Annuler',
                apply: 'Appliquer',
            },

            level1: 'Niveau 1',
            level2: 'Niveau 2',
            level3: 'Niveau 3',
            level4: 'Niveau 4',
            level5: 'Niveau 5',
            postalCode: 'Code postal',
            name: 'Désignation',
            articleNumber: 'Code produit',
            productTypology: 'Typologie produit',
            serialNumber: 'No de série',
            installingDate: 'Date d\'installation',
            maintenanceLastDate: 'Dernière maintenance',
            sludgeEmptyingLastDate: 'Dernière vidange',
            maintenanceThreshold: 'Niveau de maintenance',
            sludgeEmptyingThreshold: 'Niveau de vidange',
            sludgeEmptyingThresholdFilterDate: 'Filtre par période et événement tracé',
            sludgeEmptyingThresholdFilterLastDate: 'Période par vidange',
            sludgeMaintenanceThresholdFilterLastDate: 'Période par maintenance',
            sludgeEmptyingThresholdOrMaintenanceFilterDate: 'Dernière vidange des boues',
            addFilter: 'Ajouter un filtre',
            customize: 'Personnaliser',
            refresh: 'Actualiser',
            thresholdName: 'Libellé du niveau',
            thresholdMinValue: 'Valeur min',
            thresholdMaxValue: 'Valeur max',
            thresholdTriggerValue: 'Valeur de déclenchement',
            thresholdMinTriggerValue: 'Limite basse de l’intervalle',
            thresholdMaxTriggerValue: 'Limite haute de l’intervalle',
            thresholdMonthValue: 'Mois',
            addThreshold: 'Ajouter un niveau',
            processingCapacity: 'Capacité de traitement',
            sludgeStorageVolume: 'Volume de stockage de boues',
            totalUsefulVolume: 'Volume totale utile',
            nodeCurrentState: 'État actuel',
            nodeStateName: 'Nom de l\'état',
            nodeDateOfTakesPlace: 'Date de l\'état actuel',
            model: 'Modèle',
            weeks: 'Semaines',
            hours: 'Heures',
            days: 'Jours',
            years: 'Années',
            month: 'Mois',
            accessToFinger: 'Vue terrain',
            vueSpecifique: 'Vue spécifique',
            backofficeForms: 'Remplir formulaires',
            backofficeDocuments: 'Envoyer documents',
            backofficeMissingRefresh:
                'Pas de session (jeton de rafraîchissement). Reconnectez-vous au backoffice pour ouvrir l’app avec votre utilisateur.',
            [MAINTENANCE]: 'Maintenance',
            [SLUDGE_EMPTYING]: 'Vidange',
            [SPANC]: 'Spanc',
            actions: {
                title: 'Actions',
                managementThresholds: 'Gestion des seuils',
                defineThresholds:
                    'Liste des niveaux d\'alertes, basés sur les intervalles de temps depuis la dernière opération',
                export: 'Exporter',
                statistics: 'Statistiques',
                refresh: 'Actualiser',
                personalize: 'Personnaliser',
                editVP: 'Ajouter / Modifier un PV',
                editWC: 'Ajouter / Modifier un certificat de garantie',
                mapAvatars: 'ANCs géolocalisés',
                realTimeMonitoring: 'Suivi des ANC',
                scheduledMonitoring: 'Suivi des ANC',
                productTypology: 'Typologie produit',
                types: 'Types',
                thresholds: 'Paramètre de seuils'
            },
            error: {
                server: 'Il y a eu une erreur. Veuillez contacter l\'administrateur',
                wrongMinAmount: 'Montant minimum incorrect',
                wrongMaxAmount: 'Montant maximum incorrect',
                requiredField: 'Champs requis',
                minMustExceedPreviousMax: 'La valeur doit être supérieure au maximum précédent',
                maxMustExceedPreviousMin: 'La valeur doit être supérieure au minimum précédent',
                greaterThanZero: 'Ne peut pas être négatif'
            },
            metadataAvatarType: {
                name: 'Nom du type de produit'
            },
            help_text: {
                once_validated:
                    'Une fois validé pour voir le document envoyé cliquez sur le bouton dans la colonne “Vue terrain”'
            },
            success: {
                success: 'Les données ont été enregistrées',
                media_uploaded: 'Le média sélectionné a été téléchargé',
                media_updated: 'Le média sélectionné a été mis à jour'
            }
        },
        button: {
            confirm: 'Valider',
            submit: 'Soumettre',
            cancel: 'Annuler',
            go: {
                toThresholdPage: 'Voir les seuils',
                toAncsPage: 'Voir les ancs'
            }
        },
        common: {
            after: 'Après',
            before: 'Avant',
            loading: 'Chargement en cours, veuillez patienter',
            loadingMapData: 'Chargement des données de la carte...',
            page: 'Page',
            of: 'sur',
            loaded: 'Chargé',
            items: 'éléments',
            requests: 'Requêtes',
            remaining: 'restantes'
        },
        dashboard: {
            title: 'Tableau de bord',
            creationObjet: 'Création d\'objet',
            subtitle: 'Objets créés sur la période',
            granularity: {
                hours: 'Heure',
                day: 'Jour',
                month: 'Mois'
            },
            period: {
                menu: 'Période',
                lastWeek: 'Dernière semaine',
                lastMonth: 'Dernier mois',
                lastYear: 'Dernière année'
            },
            dateFrom: 'Après',
            dateTo: 'Avant',
            groups: {
                label: 'Groupes d\'objets',
                title: 'Sélectionner les groupes d\'objets',
                name: 'Nom',
                none: 'Tous les groupes'
            },
            error: 'Impossible de charger le graphique'
        },
        errors: {
            updatingProperty: 'Une erreur s\'est produite lors de la mise à jour d\'une propriété',
            creatingProperty: 'Une erreur s\'est produite lors de la création d\'une propriété',
            updatingType: 'Il y a eu une erreur lors de la mise à jour d\'un type',
            creatingType: 'Une erreur s\'est produite lors de la création d\'un type',
            gettingLanguage: 'Une erreur s\'est produite lors de la récupération du langage de propriété',
            languages: 'Une erreur s\'est produite lors de la récupération des langues'
        },
        headers: {
            eyebrow: {
                overview: "Vue d'ensemble",
                realTime: 'Suivi des installations · temps réel',
                every2Hours: 'Suivi des installations · mise à jour toutes les 2 heures',
                reference: 'Référentiel et administration',
            },
            description: 'Description',
            additional_info: 'Information Additionnelle',
            info: 'Information',
            type: 'Type',
            types: 'Type',
            selectAvatarTypeGroup: 'Sélectionnez le type de produit',
            confirmDelete: 'Supprimer',
            productTypeData: 'Type de produit Données',
            productType: 'Typologie produit',
            ancs: 'Suivi des ANC',
            thresholds: 'Paramètre de seuils'
        },
        mc: {
            add: 'Ajouter',
            application: 'Application',
            changePict: 'Changer de picto',
            copy: 'Copier l\'URL',
            creationDate: {
                afterFilter: 'Après',
                beforeFilter: 'Avant',
                value: 'Date de création'
            },
            downloadQrcode: 'Télécharger le QR Code',
            edit: 'Modifier',
            editDialogTitle: 'Modifier le MC',
            enabled: {
                no: 'Non',
                yes: 'Oui'
            },
            exportQrcode: 'Exporter le QR Code',
            general: 'Général',
            identification: 'Identification du module de communication',
            information: 'Information',
            mcName: 'Nommer les modules communicants',
            name: 'Nom',
            parameter: 'Paramètre « MC »',
            remove: 'Supprimer',
            showQrcode: 'Voir le QR Code',
            visitApp: 'Afficher l\'application',
            yourls: {
                shortUrl: 'Url Courte'
            }
        },
        medias: {
            addApproval: 'Ajouter agrément',
            addTechnicalSheet: 'Ajouter la fiche technique',
            addRoutineMaintenance: 'Ajouter la maintenance de routine',
            addUserGuide: 'Ajouter la guide d’utilisation et d’entretien',
            addInstallingGuide: 'Ajouter guide de pose',
            mediaFile: 'Charger un fichier',
            addReflexEmptying: 'Ajouter la Fiche Reflex Vidange',
            addReflexMaintenance: 'Ajouter la Fiche Reflex Maintenance',
            addUserBooklet: 'Ajouter le livret de l\'utilisateur'
        },
        messages: {
            confirmDelete: 'Voulez vous supprimer cette ligne?',
            confirmOperation: 'Vous êtes sur le point de supprimer un élément. Êtes-vous sur de vouloir continuer?',
            canSendApprovalLater: 'Vous pouvez envoyer l\'agrément plus tard',
            loading: 'Chargement en cours, veuillez patienter',
            error: 'Quelque chose s\'est mal passé, veuillez en informer l\'administrateur',
            success: 'L\'opération a réussi'
        },
        no: 'Non',
        objects: {
            by: 'Par',
            noNotes: 'Aucune note',
            details: 'Détails',
            notes: 'Historique',
            description: 'Description',
            mc: 'Modules communicants',
            service: 'Service',
            qrCode: 'Code QR',
            info: {
                name: 'Nom de l\'objet',
                type: 'Type d\'objet',
                description: 'Description',
                reference: 'Référence',
                created: 'Date de création',
                enterprise: 'Entreprise',
                images: 'Images',
                audios: 'Audios',
                documents: 'Documents',
                signatures: 'Signatures',
                externalIdentification: 'Identification externe',
                forms: 'Formulaires',
                gps: 'GPS',
                filter: {
                    filter: 'Filtre',
                    name: 'Nom',
                    note: 'Note',
                    traceability: 'Traçabilité'
                }
            },
            filters: {
                avatarProperties: {
                    additionalInformation: 'Information additionnelle'
                }
            },
            infoTab: 'Information'
        },
        objects2: {
            _date: 'Date de création',
            actions: {
                additionalInformation: 'Information Additionnelle',
                changeTraceability: 'Modifier la traçabilité',
                changeWebApp: 'Modifier l\'application web',
                deleteAction: {
                    keepMcsName: 'Supprimer et garder le Module de Com',
                    name: 'Supprimer'
                },
                simulateWebApp: 'Simuler Web App'
            },
            addImages: 'Cliquez ici pour ajouter des images',
            addObject: 'Ajouter un objet',
            additionalInformation: {
                actions: {
                    addNewName: 'Nouveau nom',
                    addProperty: 'Ajouter une propriété',
                    createGSTemplate: 'Créer un modèle G-Sheet',
                    editProperty: 'Modifier la propriété',
                    hidePrivate: 'Propriétés Privées invisibles',
                    importDataGS: 'Importer les données GSheet',
                    importDataTypeObject: 'Importer une donnée du type d’objet',
                    showPrivate: 'Propriétés Privées visibles'
                },
                addProperty: {
                    finish: 'Terminer',
                    helpText:
                        'Définissez l\'information supplémentaire. Le choix de l\'affichage permet de définir si l\'information est accessible sans mot de passe depuis les Applications Mobile Web compatibles (contactez nous pour en savoir plus). La définition permet de regrouper des informations entre elles.'
                },
                creator: 'Créateur',
                definition: 'Nom de la définition (la définition permet de regrouper des informations entre elles)',
                error: {
                    addColumnsData: 'Une erreur s\'est produite lors de l\'ajout de colonnes dans la feuille SC-DATA',
                    addDataTypes: 'Une erreur s\'est produite lors de l\'ajout de colonnes dans la feuille SC-DATA-TYPE',
                    addSheets: 'Vérifiez que le G-Sheet ne contient pas de données',
                    googleSheetLine: 'Le numéro de ligne doit être supérieur à un',
                    noData: 'Aucune donnée disponible.',
                    noValue: 'Valeur indéfinie',
                    properties: 'Vous devez ajouter au moins une propriété',
                    spreadsheet:
                        'Une erreur s\'est produite lors de l\'importation des données à partir de la feuille de calcul',
                    spreadsheetURL: 'L\'URL doit être une Spreadsheet'
                },
                fieldType: 'Type d’information',
                fieldTypeOptions: {
                    boolean: 'Booléen (« oui » ou « non »)',
                    date: 'Date',
                    number: 'Nombre',
                    string: 'Texte'
                },
                googleSheetURL: 'G-Sheet URL',
                helpText: {
                    additionalInformation:
                        'Configurez les informations supplémentaires que vous souhaitez enregistrer sur votre objet',
                    createSpreadsheetsTemplate:
                        'Configurez les propriétés que vous voulez générer dans votre fichier G-Sheet',
                    definition: 'La définition permet de regrouper des informations entre elles.',
                    fieldType:
                        'Le type d\'information est un paramètre qui peut être utilisé dans des fonctionnalités tiers ou Application Mobile compatible (contactez nous pour en savoir plus).',
                    googleSheet:
                        'Afin d\'importer des données à partir d\'un fichier G-Sheet, veuillez vous assurer que le format de données est compatible',
                    googleSheetLine: 'Vous devez écrire le numéro de ligne à importer.',
                    googleSheetURL: 'Veuillez insérer le lien de partage de fichiers G-Sheet.',
                    name: 'Définissez le titre de l’information supplémentaire',
                    private:
                        'Le choix de l\'affichage défini si l\'information est accessible sans mot de passe depuis les Applications Mobile Web compatible (contactez nous pour en savoir plus).',
                    spreadsheetCreate: 'Le modèle G-Sheet a été créé',
                    unit: 'Unité'
                },
                lineNumber: 'Choix du numéro de ligne',
                lineToImport: 'Choix du numéro de ligne (exemple « 1-4 »)',
                name: 'Titre de l’information',
                private: 'Règle d\'affichage',
                privateOptions: {
                    private:
                        'Privé : la donnée de l\'information sera crypté et pourra être visible lorsque qu\'un utilisateur ayant les droit est identifié.',
                    public: 'Public : l\'information sera visible sans avoir besoin de s\'identifier avec un compte depuis les Web Applications utilisant les informations supplémentaire de l\'objet.'
                },
                title: 'Information additionnelle',
                tooltipActionIcons: {
                    edit: 'Modifier',
                    private: 'Information Privée',
                    remove: 'Effacer',
                    required: 'Information requise'
                },
                unit: 'Unité',
                value: 'Valeur (données) d’information'
            },
            alphaId: 'Référence',
            applications: 'Service de redirections',
            bulk_action: {
                addToObjectGroup: 'Grouper',
                addTraceability: 'Traçabilité',
                changeFinger: 'Redirection',
                error: {
                    diferentCompany:
                        'Veuillez vérifier que tous les objets appartiennent au même compte du groupe d’objet %{object_group_name}',
                    headerTable: 'Erreur',
                    notAdded: 'L\'objet n\'a pas été ajouté au groupe',
                    notChangeApp: 'La redirection n\'a pas été modifiée',
                    notChangeTraceability: 'La traçabilité n\'a pas été modifiée',
                    notRemoveFromGroup: 'L\'objet n\'a pas été supprimé au groupe',
                    title: 'Certains objets n\'ont pas été mis à jour',
                    titleUpdateMCs: 'Le MC n\'a pas été mis à jour'
                },
                removeToObjectGroup: 'Dissocier',
                titleAddToGroup: 'Choisissez un groupe d\'objet afin de mettre à jour les objects choisis',
                titleAddTraceability:
                    'Choisissez un processus de traçabilité à modifier. Veuillez noter que le changement ne fonctionne que si l\'objet utilise une application Web qui utilise la traçabilité (ex: MemoTagPro)',
                titleChangeFinger: 'Choisissez une redirection afin de mettre à jour les objects choisis',
                titleChangeFingerForMC: 'Choisissez une redirection afin de mettre à jour le MC',
                titleRemoveGroup: 'Choisissez le groupe que vous souhaitez dissocier de l\'objet sélectionné'
            },
            createModal: {
                p1text1: 'Pour enregistrer ou ajouter un objet sur la plateforme, vous devez utiliser l',
                p1text2: 'application mobile d\'appairage',
                p1text3: ' sur l\'',
                p1text4: 'objet réel',
                p1text5: ' intégrant un ou plusieurs module(s) communicant(s) de type NFC ou QR Code.',
                p2text1: 'Pour plus d\'informations contactez le ',
                p2text2: 'support'
            },
            createObject: {
                advancedForm: 'Formulaire Avancé',
                error: {
                    addToGroup: 'Ce n\'est pas possible d\'ajouter l\'objet au groupe d\'objets',
                    createMc: 'MC n\'a pas pu être créé',
                    simulateMc: 'La simulation des mcs n\'a pas été effectuée'
                },
                finger: {
                    add: 'Ajouter des redirections'
                },
                groupObjects: {
                    add: 'Groupe d\'objets'
                },
                helpText: {
                    chooseTypeObject: 'Choisissez votre type d\'objet pour pré-configurer votre nouvel objet :',
                    createObject:
                        'Vous êtes sur le point de créer un objet manuellement. Il existe une façon plus optimisée de créer un objet, pour cela consultez cette page',
                    createObjectPage: 'Comment créer un objet'
                },
                notification: {
                    addToGroup: 'L\'objet a été ajouté au groupe',
                    copied: 'Copié dans le presse-papiers'
                },
                simplifiedForm: 'Forme Simplifiée',
                title: 'Créer un objet',
                validatePrevData: 'Validez les données pré-remplies'
            },
            createObjectMultiple: {
                errors: {
                    emptyLine: 'Un problème est survenu. Une ligne sans valeur',
                    nogapi: 'Impossible d\'accéder à l\'API google. Veuillez contacter l\'administrateur du service.',
                    notFoundDataInTableInSpreadsheet: 'La %{table} n\'a pas des données',
                    notFoundPropertyInTable: 'La proprieté %{property} n\'est pas dans le tableau %{table}',
                    notFoundTableInSpreadsheet: 'La %{table} n\'est pas dans le spreadsheet',
                    readLine: 'Les numéros de ligne à importer n\'ont pas de données',
                    spreadsheet:
                        'Une erreur s\'est produite lors de l\'importation des données à partir de la feuille de calcul'
                },
                helpText: {
                    amount: 'Nombre d\'objets à créer',
                    step1CreateObject: 'Comment créer un objet',
                    step1Part1:
                        'Vous êtes sur le point de créer un objet manuellement. Il existe une manière plus optimisée de créer un objet, pour cela voir cette page',
                    step1Part2: 'Choisissez votre type d\'objet pour préconfigurer votre nouvel objet',
                    step2ValidatePreFillData: 'Validez ces données pré-remplies',
                    step3Line1:
                        'Pour importer les données d\'un fichier G-Sheet, veuillez à ce que le format de donnée soit compatible.',
                    step3Line2: 'Veuillez insérer le lien de partage du fichier G-Sheet.',
                    step3Line3:
                        'Vous devez choisir le numéro ligne à importer, de la première ligne à la dernière ligne séparé par un tiret, exemple "2-6".',
                    step3Line4: 'Les lignes suivantes vont être crée en tant qu\'objet :',
                    withFile: 'Création avec un tableau G-sheet :',
                    withoutFile: 'Sans fichier'
                },
                title: 'Créer plusieurs objets'
            },
            currentStateName: 'Statut',
            date: 'Date de création',
            dateTitle: 'Date de création :',
            deleteModal: 'Êtes vous sûre de vouloir archiver l\'élément(s) séléctionné(s)?',
            deleteModalAlways: 'Êtes vous sûre de vouloir supprimer l\'élément(s) séléctionné(s)?',
            deleteModalNotCancel: 'Êtes vous sûre de vouloir supprimer l\'élément séléctionné ?',
            deploy: 'Déployer',
            description: 'Description',
            documents: 'Documents',
            editObject: {
                add: {
                    mc: {
                        added: 'Le Module Communicant a été ajouté',
                        error: 'Le Module Communicant n\'a pas été ajouté',
                        title: 'Ajouter un Module Communicant à l\'objet'
                    }
                },
                title: 'Modifier l’objet'
            },
            export: {
                historic: {
                    csv: 'Historique (CSV)',
                    xlsx: 'Historique (XLSX)'
                },
                objects: {
                    csv: 'Inventaire (CSV)',
                    xlsx: 'Inventaire (XLSX)'
                }
            },
            filters: {
                avatarProperties: {
                    additionalInformation: 'Informations Complémentaires',
                    definitionInput: 'IC - Classement',
                    definitionLabel: 'Informations complémentaires - Classement',
                    nameInput: 'IC - Nom',
                    nameLabel: 'Informations complémentaires - Nom',
                    valueInput: 'IC - Valeur',
                    valueLabel: 'Informations complémentaires - Valeur'
                },
                business: 'Affaire',
                creationDate: 'Date de création',
                creationDateAfter: 'Date de création - Après',
                creationDateBefore: 'Date de création - Avant',
                factory: 'Usine',
                historyCreated: 'Date de l\'historique',
                historyCreatedAtAfter: 'Date de l\'historique - Après',
                historyCreatedAtBefore: 'Date de l\'historique - Avant',
                history_name: 'Nom du Statut',
                metadataAvatarType: 'Type d\'Objet',
                objectGroup: 'Groupe d\'objet',
                objectName: 'Nom de l\'objet',
                parent: 'Parent d\'objet',
                shortUrl: 'ShortUrl',
                site: 'Chantier',
                typeObject: 'Nom du type d\'objet'
            },
            finger: 'Finger',
            generate: {
                create_from_file: 'Créer des MCs à partir d\'un fichier',
                simulate: 'Simuler'
            },
            groupObjects: 'Groupe d\'objets',
            historic: 'Historique',
            info: {
                additionalAddress: 'Complément d\'adresse',
                address: 'Adresse',
                altitude: 'Altitude',
                amountNotes: 'Nombre de notes',
                attachDocuments: 'Ajouter des documents',
                attachImage: 'Importer une image',
                attachImages: 'Ajouter des images',
                attachOneImage: 'Ajouter une image',
                chooseRootObjectType: 'Choisissez le type d\'objet racine',
                city: 'Ville',
                country: 'Pays',
                created: 'Date de création',
                createdAt: 'Date de Création',
                description: 'Description',
                enabled: 'Activé',
                enabledDate: 'Date d\'activation',
                enterprise: 'Entreprise',
                extradata: 'Données supplémentaires',
                extradata_infos: {
                    dimension: 'Dimension',
                    empty_: 'Veuillez lancer le Finger (WebApp) afin de les consulter ou contactez l\'admin pour la personnalisation',
                    profession_data: 'Données Métier'
                },
                filter: {
                    apply: 'Appliquer en tant que filtre',
                    avatarGroup: 'Groupe d\'objet',
                    company: 'Entreprise',
                    history_created_at: {
                        afterFilter: 'Date historique - Après',
                        beforeFilter: 'Date historique - Avant',
                        value: 'Date historique'
                    },
                    metadataAvatarType: 'Type d\'objet',
                    name: 'Filtre',
                    note: 'Notes',
                    traceability: 'Traçabilité'
                },
                groupAvatar: {
                    name: 'Groupes'
                },
                id: 'Id',
                image: 'Image',
                images: 'Images',
                inputMap: 'Cliquez dans le texte pour afficher la carte',
                lastNote: 'Dernière note',
                latitude: 'Latitude',
                localization: 'Localisation',
                longitude: 'Longitude',
                mcs: 'Modules de Communication',
                name: 'Nom de l\'objet',
                nature: 'Type de MC',
                parent: 'Parent objet',
                position: 'Position de l\'objet',
                postalCode: 'Code postal',
                redirectTo: {
                    show: {
                        company: 'Afficher dans la page entreprise',
                        metadataAvatarType: 'Afficher dans la page type d\'objet'
                    }
                },
                reference: 'Référence',
                showImages: 'Afficher toutes les images',
                stateObject: 'Statut de l\'objet',
                statistics: 'Statistiques',
                statistics_redirection: {
                    title: 'Statistiques détaillées de l\'objet'
                },
                street: 'Rue',
                tracking: {
                    _date_state: 'Date du statut',
                    currentNode: 'Nœud actuel',
                    date_state: 'Date du Statut',
                    fullName: 'Nom et prénom',
                    goNext: 'Suivant',
                    goPrevious: 'Précédent',
                    name_state: 'Statut',
                    selectNode: 'Sélectionnez un nœud',
                    title: 'Suivi'
                },
                type: 'Type d\'objet'
            },
            information: 'Information',
            interfaces: 'Interface',
            list: {
                actions: {
                    customize_list: 'Personnaliser'
                }
            },
            location: 'Emplacement',
            mc: 'Modules Communicants',
            moduleCommunications: 'Modules communicants',
            name: 'Nom',
            nameObject: 'Nom de l’objet',
            nature: {
                nfc: 'NFC',
                qrcode: 'QrCode',
                st25: 'ST25'
            },
            notDefined: 'Non défini',
            notSelected: 'Aucun objet n\'est sélectionné',
            object: 'Objet',
            objectMenu: {
                title: 'Choisissez un objet'
            },
            objectType: 'Type d\'objet',
            objects: 'Objets',
            openHistory: 'Ouvrir l\'historique',
            photoObject: 'Photo de l’objet',
            quantityMCs: 'Nombre de Modules',
            service: 'Nom du service de redirection',
            tabs: {
                mc: 'STOCK NON APPAIRÉ DE MODULES COMMUNICANTS'
            },
            type: 'Type Objet',
            typeObject: {
                applicationDisponibles: 'Service de redirection disponibles'
            },
            typesObjects: 'Type d\'objets',
            url: 'Url',
            webServiceDisplay: 'Service Web à afficher'
        },
        productType: {
            create: 'Créer',
            edit: 'Modifier',
            name: 'Typologie produit',
            yes: 'Oui',
            no: 'Non',
            approval: 'Agrément',
            approvalFile: 'Charger un fichier d\'agrément',
            mediaFile: 'Charger un fichier',
            addApproval: 'Ajouter agrément',
            editApproval: 'Modifier agrément',
            addItem: 'Créer',
            editItem: 'Modifier',
            deleteItem: 'Supprimer',
            messages: {
                success: 'Les données ont été enregistrées',
                error: 'Une erreur s\'est produite'
            },
            success: {
                updated: 'La typologie produit a été mis à jour'
            },
            error: {
                server: 'Il y a eu une erreur. Veuillez contacter l\'administrateur'
            }
        },
        sidebar: {
            anc: 'Suivi des ANC',
            appName: 'Backoffice ANC',
            realTimeShort: 'temps réel',
            every2HoursShort: 'toutes les 2 h',
            sections: {
                monitoring: 'Suivi',
                reference: 'Référentiel',
            },
            every2Hours: 'Mise à jour toutes les 2 heures',
            realTime: 'Mise à jour en temps réel',
            product_type: 'Typologie produit',
            type: 'Type',
            threshold_settings: 'Paramètre de seuils',
            disconnect: 'Se déconnecter',
        },
        prestataires: {
            title: 'Prestataires',
            menu: 'Prestataires',
            columns: {
                companyName: 'Entreprise',
                types: 'Type(s)',
                departments: 'Départements',
                email: 'Email',
                actions: 'Actions',
            },
            list: {
                empty: 'Aucun prestataire affilié pour le moment.',
                summary: '%{companies} entreprise(s) prestataire(s)',
            },
            actions: {
                add: 'Ajouter un prestataire',
                refresh: 'Actualiser',
                cancel: 'Annuler',
                back: 'Retour',
                next: 'Suivant',
                link: 'Lier',
                submit: 'Enregistrer',
                save: 'Enregistrer',
                edit: 'Modifier',
                unlink: 'Dissocier',
                viewPdf: 'Voir le document d’homologation',
                createAndLink: 'Créer',
            },
            fields: {
                types: 'Types de prestation',
                departments: 'Départements',
                departmentsHelp: 'Cliquez les départements sur la carte ou recherchez une adresse',
                departmentsForType: 'Départements — %{type}',
                addressSearch: 'Rechercher une adresse (IGN)',
                departmentsMapHelp: 'Cliquez un département pour l’ajouter ou le retirer. L’adresse du siège préremplit le département correspondant.',
                departmentSearch: 'Ajouter un département (code ou nom)',
                copyDepartmentsFrom: 'Copier les départements de…',
                clearDepartments: 'Tout effacer',
                email: 'Email du prestataire',
                companyName: 'Raison sociale',
                siret: 'SIRET',
                adminEmail: 'Email admin',
                adminPassword: 'Mot de passe admin',
                adminName: 'Prénom admin',
                adminLastName: 'Nom admin',
                street: 'Adresse',
                additionalAddress: "Complément d'adresse",
                postalCode: 'Code postal',
                city: 'Ville',
                country: 'Pays',
            },
            types: {
                MISE_EN_SERVICE: 'Mise en service',
                ENTRETIEN: 'Entretien',
                REPARATION: 'Réparation',
            },
            wizard: {
                title: 'Ajouter un prestataire',
                steps: {
                    siret: 'SIRET',
                    details: 'Informations',
                    company: 'Entreprise',
                    zone: "Zone d'intervention",
                },
                siretHelp: "Saisissez le SIRET de l'entreprise : nous vérifions si elle existe déjà dans le système.",
                choosePdf: 'Choisir un PDF',
                found: 'Entreprise déjà présente dans le système',
                foundHelp: 'Elle sera liée à votre compte, inutile de la recréer. Indiquez ses types de prestation et départements.',
                notFound: 'Aucune entreprise avec le SIRET %{siret} dans le système',
                alreadyAffiliated: '%{name} est déjà affiliée à votre compte.',
                notEligible: "%{name} existe dans le système mais n'est ni installateur, ni mainteneur, ni vidangeur : elle ne peut pas être affiliée.",
                companyBlock: "Informations de l'entreprise",
                adminBlock: 'Administrateur du compte',
                annuairePrefilled: "Préremplies depuis l'Annuaire des Entreprises, vérifiez-les avant d'enregistrer.",
                annuaireClosed: "Attention : cet établissement est fermé selon l'Annuaire des Entreprises.",
                siretDigits: '%{count}/14 chiffres',
                createHelp: "Renseignez ses informations : l'entreprise et son compte administrateur seront créés.",
                adminHelp: "Ce compte permettra au prestataire de se connecter à l'application.",
                adminEmailIsLogin: "Servira d'identifiant de connexion",
                generatePassword: 'Générer un mot de passe sécurisé',
                showPassword: 'Afficher le mot de passe',
                hidePassword: 'Masquer le mot de passe',
                zoneHelp: 'Choisissez les prestations réalisées par %{name} et, pour chacune, les départements couverts.',
            },
            zone: {
                title: "Zone d'intervention par prestation",
                recenter: 'Recentrer sur la France',
                legendActive: 'Prestation en cours',
                legendOther: 'Autres prestations',
                addRegion: 'Ajouter / retirer une région',
                applyToAll: 'Appliquer à toutes les prestations',
                selectedCount: '%{smart_count} département sélectionné |||| %{smart_count} départements sélectionnés',
                emptySelection: 'Aucun département. Cliquez sur la carte, recherchez un département ou ajoutez une région.',
                pickTypeFirst: "Sélectionnez au moins un type de prestation pour définir sa zone d'intervention.",
            },
            edit: {
                title: "Modifier l'affiliation",
                replacePdf: 'Remplacer le document d’homologation (optionnel)',
                addPdf: 'Ajouter le document d’homologation (optionnel)',
                replacePdfHelp: 'Laissez vide pour conserver le document actuel.',
            },
            validation: {
                typesRequired: 'Sélectionnez au moins un type',
                departmentsRequired: 'Indiquez au moins un département valide',
                departmentsRequiredForType: 'Sélectionnez au moins un département pour %{type}',
                siretInvalid: 'Le SIRET doit contenir 14 chiffres',
                required: 'Champ obligatoire',
                emailInvalid: 'Adresse email invalide',
            },
            messages: {
                createSuccess: 'Prestataire ajouté avec succès',
                updateSuccess: 'Affiliation mise à jour',
                unlinkSuccess: 'Affiliation dissociée',
                confirmUnlink: 'Dissocier ce prestataire ?',
                pdfUnavailable: 'Aucun document d’homologation',
                missingCompany: 'Société fabricant introuvable',
                error: 'Une erreur est survenue',
            },
        },
        login: {
            heroTitle: "Suivi des installations d'assainissement non collectif",
            heroText: 'De la livraison à la mise en service : traçabilité, signatures et documents de chaque installation.',
            title: 'Connexion',
            subtitle: 'Identifiez-vous avec votre compte Rikutec.',
            username: 'Identifiant',
            password: 'Mot de passe',
            submit: 'Se connecter',
            error: 'Identifiant ou mot de passe incorrect',
        },
        pwa: {
            info: 'Info',
            title: 'Ajouter à l\'écran d\'accueil',
            intro: 'Vous pouvez accéder à l\'application comme une app depuis votre téléphone.',
            close: 'Fermer',
            qr: {
                title: 'Ouvrir sur mobile',
                hint: 'Scannez ce code avec l\'appareil photo de votre téléphone pour ouvrir le backoffice.',
            },
            install: {
                title: 'Installer l\'application',
                message:
                    'Ajoutez Rikutec à votre écran d\'accueil pour y accéder directement, comme une application.',
                action: 'Installer',
                later: 'Plus tard',
            },
            android: {
                title: 'Android (Chrome)',
                step1: 'Ouvrez le site dans Chrome.',
                step2: 'Appuyez sur le menu ⋮ en haut à droite.',
                step3: 'Sélectionnez « Ajouter à l\'écran d\'accueil » ou « Installer l\'application ».',
            },
            ios: {
                title: 'iOS (Safari)',
                step1: 'Ouvrez le site dans Safari.',
                step2: 'Appuyez sur le bouton Partager en bas de l\'écran.',
                step3: 'Sélectionnez « Sur l\'écran d\'accueil », puis validez.',
            },
        },
        traceabilityNotesThreshold: {
            name: 'Seuil',
            operationType: 'Type d\'opération',
            objectType: 'Type de produit',
            activeEvent: 'Événement actif',
            deleted: 'Le seuil a bien été supprimé',
            actions: {
                title: 'Actions',
                addEvent: 'Ajouter un seuil',
                deleteEvent: 'Supprimer un seuil',
                editEvent: 'Modifier le seuil séléctionné',
                managementThresholds: 'Gestion des seuils',
                defineThresholds:
                    'Liste des niveaux d’alertes, basés sur les intervalles de temps depuis la dernière opération',
                export: 'Exporter',
                statistics: 'Statistiques',
                refresh: 'Actualiser',
                personalize: 'Personnaliser',
                delete: {
                    title: 'Supprimer le seuil?',
                    message: 'Êtes-vous sûr de vouloir supprimer le seuil?'
                }
            },
            error: {
                server: 'Il y a eu une erreur. Veuillez contacter l\'administrateur',
                uniqueMetadataAvatarType: 'Il existe une notification liée à ce type d\'objet',
                set: {
                    groupAvatar: 'Le groupe de l\'objet doit être défini',
                    avatar: 'L\'objet doit être défini',
                    metadataAvatarType: 'Le type d\'objet doit être défini'
                }
            },
            maintenance: {
                name: 'Seuil de maintenance'
            },
            emptying: {
                name: 'Seuil de vidange'
            }
        },
        types: {
            productName: 'Désignation',
            productType: 'Typologie Produit',
            alpha_id: 'Alpha Id',
            id: 'Id',
            name: 'Nom du type',
            processingCapacity: 'Capacité de traitement',
            sludgeStorageVolume: 'Volume dédié au stockage des boues',
            totalUsefulVolume: 'Volume totale utile',
            model: 'Modèle',
            itemCode: 'Code d\'article',
            typeSerialNumber: '4 premiers chiffres du numéro de série',
            create: 'Créer Type',
            edit: 'Modifier',
            empty: '<vide>',
            addEditInstallingGuide: 'Ajouter / Modifier guide de pose',
            addEditinstalling_guide: 'Ajouter / Modifier guide de pose',
            installing_guide: 'Guide de pose',
            user_booklet: 'Livret de l\'utilisateur',
            mediaFile: 'Charger un fichier',
            user_guide: 'Guide d’utilisation et d’entretien',
            reflex_emtying: 'Fiche Reflex Vidange',
            reflex_maintenance: 'Fiche Reflex Maintenance',
            technical_sheet: 'Fiche technique',
            routine_maintenance: 'Maintenance de routine',
            addReflexEmtying: 'Ajouter la Fiche Reflex Vidange',
            addReflexMaintenance: 'Ajouter la Fiche Reflex Maintenance',
            addInstallingGuide: 'Ajouter la guide de pose',
            addUserGuide: 'Ajouter la guide d’utilisation et d’entretien',
            addUserBooklet: 'Ajouter le livret de l\'utilisateur',
            enableApproval: 'Activer l\'agrément',
            disableApproval: 'Désactiver l\'agrément',
            approvalEnabled: 'Agrément activé',
            approvalDisabled: 'Agrément désactivé',
            addTechnicalSheet: 'Ajouter la fiche technique',
            addRoutineMaintenance: 'Ajouter la maintenance de routine',
            addEditUserGuide: 'Ajouter / Modifier le mode d\'emploi',
            addEdituser_guide: 'Ajouter / Modifier le mode d\'emploi',
            addEditTechnicalSheet: 'Ajouter / Modifier la fiche technique',
            addEdittechnical_sheet: 'Ajouter / Modifier la fiche technique',
            addEditRoutineMaintenance: 'Ajouter / Modifier la Maintenance de routine',
            addEditroutine_maintenance: 'Ajouter / Modifier la Maintenance de routine',
            yes: 'Oui',
            no: 'Non',
            messages: {
                success: 'Les données ont été enregistrées',
                error: 'Une erreur s\'est produite'
            }
        },
        notification: {
            copied: 'Copié avec succès'
        },
        download: 'Télécharger',
        validation: {
            required: 'Champ requis'
        },
        yes: 'Oui'
    },
};

// Ajouts des traductions pour le module des notes
// Étendre l'objet existant sans gros diff
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(locale.app as any).notes = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...(locale.app as any).notes,
    makeBy: 'Fait par',
    formsDialog: 'Formulaires',
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(locale.app as any).main_buttons = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...(locale.app as any).main_buttons,
    actions: 'Actions',
    back: 'Retour',
    create: 'Créer',
    delete: 'Supprimer',
    edit: 'Modifier',
    next: 'Suivant',
    openForms: 'Voir le formulaire',
    return: 'Retour',
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(locale.app as any).objects = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...(locale.app as any).objects,
    documents: 'Documents',
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(locale.app as any).signs = 'Signatures';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(locale.app as any).rikutec = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...(locale.app as any).rikutec,
    externalIdentification: {
        label: 'Identification externe',
        name: 'Nom',
        email: 'Email',
    },
};

export default locale;
